function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg09N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.806,
    height: 29.138,
    viewBox: "0 0 35.806 29.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "09n"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184463"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14420",
    d: "M69.11 190.423a3.8 3.8 0 0 0-3.756-2.942 3.909 3.909 0 0 0-2.392.809 6.807 6.807 0 0 0-6.082-3.643 6.7 6.7 0 0 0-6.723 5.693 4.522 4.522 0 0 0-3.625 4.353 4.567 4.567 0 0 0 4.638 4.464h16.593a4.567 4.567 0 0 0 4.638-4.464 4.507 4.507 0 0 0-3.291-4.27z",
    transform: "translate(-46.531 -179.462)",
    style: {
      fill: "#d32f2f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184461"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14421",
    d: "M70.614 190.979a5.377 5.377 0 0 1 4.356-2.325.322.322 0 0 0 0-.644 6.058 6.058 0 0 0-4.912 2.644c-.238.34.32.662.556.325z",
    transform: "translate(-64.64 -182.057)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184462"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14422",
    d: "M50.944 217.785a3.5 3.5 0 0 1 1.641-2.916c.348-.223.026-.78-.325-.556a4.166 4.166 0 0 0-1.96 3.472.322.322 0 0 0 .644 0z",
    transform: "translate(-49.438 -202.314)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184616"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14415",
    d: "M498.992 57.275a5.073 5.073 0 0 0-5.092-4.312 5.156 5.156 0 0 0-4.607 2.759 4.525 4.525 0 0 0-4.181 0c-2.327 1.089-1.619 4.3-1.619 4.346.727-.837 2.785-.725 3.75 0a5 5 0 0 1 2.366 3.888h8.616a3.459 3.459 0 0 0 3.513-3.382 3.426 3.426 0 0 0-2.746-3.299z",
    transform: "translate(-465.933 -52.963)",
    style: {
      fill: "#e06d6d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184455"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184454"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14416",
    d: "M530.209 57.741a3.356 3.356 0 0 1 3.107 2.2c.127.341.679.193.551-.152a3.945 3.945 0 0 0-3.657-2.623.286.286 0 0 0 0 .571z",
    transform: "translate(-501.845 -56.208)",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184476"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184465"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184464"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14423",
    d: "m86.214 252 1.674 2.641c.2.309.691.023.493-.288l-1.674-2.641c-.2-.309-.691-.023-.493.288z",
    transform: "translate(-77.117 -231.11)",
    style: {
      fill: "#283593"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184467"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184466"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14424",
    d: "m102.577 255.187 1.674 2.641c.2.309.691.023.493-.288l-1.674-2.641c-.2-.309-.691-.023-.493.288z",
    transform: "translate(-89.743 -233.568)",
    style: {
      fill: "#283593"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184469"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184468"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14425",
    d: "m98.478 272.777 1.674 2.641c.2.309.691.023.493-.288l-1.674-2.641c-.2-.309-.691-.023-.493.288z",
    transform: "translate(-86.58 -247.141)",
    style: {
      fill: "#283593"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184471"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184470"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14426",
    d: "m83.524 267.443 1.674 2.641c.2.309.691.023.493-.288l-1.674-2.641c-.2-.309-.691-.023-.493.288z",
    transform: "translate(-75.041 -243.025)",
    style: {
      fill: "#283593"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184473"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184472"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14427",
    d: "m114.841 275.962 1.674 2.641c.2.309.691.023.493-.288l-1.674-2.641c-.2-.309-.691-.023-.493.288z",
    transform: "translate(-99.206 -249.598)",
    style: {
      fill: "#283593"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184475"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184474"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14428",
    d: "m118.508 259.566 1.674 2.641c.2.309.691.023.493-.288L119 259.278c-.2-.309-.691-.023-.493.288z",
    transform: "translate(-102.036 -236.947)",
    style: {
      fill: "#283593"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg09N);
export default __webpack_public_path__ + "static/media/09N.587faa9ca6c773d62056093eef53235f.svg";
export { ForwardRef as ReactComponent };